import React, { useState } from "react";
import { randomThinkingWord } from "../thinkingWords";
import { randomSparkVariant } from "../sparkVariants";

/**
 * The single live "working" indicator shown between steps: Claude's animated
 * "spark" icon (one of five animation variants, rolled per turn) and a playful
 * gerund (picked once per appearance) that shimmers with a traveling band of
 * brand orange.
 */
export default function TypingIndicator({ showAvatar = true, word, spark }) {
  // The caller (EventList) supplies a word + spark variant that are stable for
  // the whole turn so they don't change when this indicator briefly remounts.
  // Fall back to local random picks if used standalone without them.
  const [fallback] = useState(randomThinkingWord);
  const [sparkFallback] = useState(randomSparkVariant);
  const label = word || fallback;
  const variant = spark !== undefined ? spark : sparkFallback;
  return (
    <div className="ca-step ca-step--thinking ca-step--live running" role="status" aria-live="polite">
      <div className="ca-msg-avatar" aria-hidden="true">
        {showAvatar && (
          <span className={`ca-spark${variant ? ` ca-spark--${variant}` : ""}`}>
            <span className="ca-spark-frames" />
          </span>
        )}
      </div>
      <div className="ca-step-main">
        <div className="ca-step-row">
          <span className="ca-step-label ca-step-shimmer">{label}...</span>
        </div>
      </div>
    </div>
  );
}
